import React, { Component } from 'react';
import { getName, saveName, clearLocalStorage } from "./api/localstorage";

class Intro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: undefined
    };
  }

  componentDidMount() {
    const name = getName();
    if (name) {
      this.setState({
        name: name
      });
    }
  }

  renderWelcomeBackMsg = () => {
    return (
      <div>
        <p>Welcome back <strong>{this.state.name}</strong> ! &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Not you? &nbsp; <button type="button" className="btn_changeUser" onClick={this.handlechangeUserBtn}>Logout</button> </p>
        <p>Ready to continue recording?</p>
      </div>
    );
  };

  renderInput = () => {
    return (
      <div>
        <p>To get started, enter your email address and hit the Next button.</p>
        <input type="text" id="emailTextField" placeholder="Your Email" onChange={this.handleInput} />
      </div>
    );
  };

  handleInput = e => {
    this.setState({ name: e.target.value });
  };

  handlechangeUserBtn = () => {
    clearLocalStorage();
    window.location = '/';
  };


  render() {
    return (
      <div className="page-intro">
        <br />
        <br />
        <div id="PageIntro">
          {getName() ? this.renderWelcomeBackMsg() : this.renderInput()}
          <br />
          <br />
          <div className="btn_PageIntro">
            <button id="btn_PageIntro" className="btn" onClick={this.handleTrainMimicBtn}>
              {getName() ? "Let's Go" : "Next"}
              <i className="fas ibutton-continue fa-arrow-right" />
            </button>
          </div>
        </div>
        <br />
        <hr />
        <br />
        <br />
        <br />
        <div>
          <p>Listen to pre-trained voices instead? &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <button type="button" className="btn_changeUser" onClick={this.handleListenBtn}>CLICK HERE </button> </p>
        </div>
      </div>
    );
  }


  handleTrainMimicBtn = () => {
    if (this.state.name === undefined) {
      alert("Please input an email before proceeding!");
    } else {
      saveName(this.state.name);
      this.props.history.push('/record');
    }
  };

  handleListenBtn = () => {
    this.props.history.push('/listen');
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/App/Intro.js